module.exports = __webpack_public_path__ + "img/logo.6184f12b.png";